




































import { computed, defineComponent } from '@vue/composition-api';
import { getPresentationConfig } from '@/shared/verify-credit-controller';
import { VerifyStageEnum } from '@/shared/verify-credit-controller/types';
import { useMaxQuotaText } from '@/shared/utils/getMaxQuota';
import ActivityRule from '@/components/activity-rule/index.vue';
import store from '@/store';
import { TipMsgType } from '../../types';

export default defineComponent({
  components: {
    ActivityRule,
  },
  props: {
    topMsg: {
      default: {},
    },
    showLoanTitle: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const topMsg = computed<TipMsgType>(() => (props.topMsg));
    const maxQuota = useMaxQuotaText();
    const titleAfterText = computed(() => {
      const { idCardActivityTitle, isLoadingActivityConfig } = store.state.verifyCredit;
      const text = idCardActivityTitle || getPresentationConfig()[VerifyStageEnum.ID_CARD]?.title || `最高可借${maxQuota.value}`;
      /** 配置读取时，展示"空"避免元素闪烁 */
      return isLoadingActivityConfig ? '' : text;
    });

    return {
      topMsg,
      titleAfterText,
    };
  },
});
